// Zendesk SSO deep-links to the Q-Scout help center. Shared so the Help menu
// and the NoAccess page point at the same, env-overridable destinations.
const defaultDocumentationCenterUrl =
  'https://kryptowire.zendesk.com/auth/v2/login/continue_with_sso_tracking?remote_auth_id=35808239917719&role=consumer&return_to=https%3A%2F%2Fqscout.zendesk.com%2Fhc%2Fen-us%3Fbrand_id%3D15285973673879&brand_id=15285973673879';
const defaultCustomerSupportUrl =
  'https://kryptowire.zendesk.com/auth/v2/login/continue_with_sso_tracking?remote_auth_id=35808239917719&role=consumer&return_to=https%3A%2F%2Fqscout.zendesk.com%2Fhc%2Fen-us%2Frequests%3Fbrand_id%3D15285973673879&brand_id=15285973673879';

export const zendeskSSOUrls = {
  documentationCenter: process.env.ZENDESK_DOCUMENTATION_CENTER_URL || defaultDocumentationCenterUrl,
  customerSupport: process.env.ZENDESK_CUSTOMER_SUPPORT_URL || defaultCustomerSupportUrl,
};
